













































































































































































































































































































import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy, EstadoEntidad } from '@/config/enums';
import config from '@/config/index';
import HandleErrors from '@/config/handleErrors';
import Confirmation from '@/components/Confirmation.vue';
import { IClientes } from '@/interfaces/Clientes';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';
import { Validator } from 'vee-validate';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { Funcionalidades } from '@/config/funcionalidades';
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
@Component({
  components: {
    'app-confirmacion': Confirmation,
  },
})
export default class ClienteModalEdicion extends ComponenteBaseStepper {
  @Prop({ default: false }) show!: boolean;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({
    default: () => ({ id: 0, nombre: '', estado: EstadoEntidad.Activo }),
  })
  cliente!: IClientes;

  readonly controllerCliente: string = 'cliente';

  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Clientes;
  permisosActuales: PermisoAccionVm[] = [];

  informacionGeneral: PermisoAccionVm = {
    accion: 'Editar - Información General',
    visible: true,
    step: 1,
    codigoSubAccion: 19,
    codigoAccionPadre: CodigoAccion.Editar,
  };

  configurarCliente: PermisoAccionVm = {
    accion: 'Editar - Configurar Cliente',
    visible: true,
    step: 2,
    codigoSubAccion: 31,
    codigoAccionPadre: CodigoAccion.Editar,
  };

  informacionGeneralVerDetalle: PermisoAccionVm = {
    accion: 'Ver Detalle - Información General',
    visible: true,
    step: 1,
    codigoSubAccion: 19,
    codigoAccionPadre: CodigoAccion.VerDetalle,
  };

  configurarClienteVerDetalle: PermisoAccionVm = {
    accion: 'Ver Detalle - Configurar Cliente',
    visible: true,
    step: 2,
    codigoSubAccion: 31,
    codigoAccionPadre: CodigoAccion.VerDetalle,
  };

  permisosTotales: PermisoAccionVm[] = [
    this.informacionGeneral,
    this.configurarCliente,
    this.informacionGeneralVerDetalle,
    this.configurarClienteVerDetalle,
  ];

  //Variables globales
  $snotify: any;
  bottomNav: any = '1';
  btnText: string = 'Continuar';
  dialog: boolean = false;
  validForm: boolean = false;
  editedItem: IClientes = {};
  dictionaryFormErrors: any = {};
  dialogConfirmacion: boolean = false;
  handleErrors: HandleErrors = new HandleErrors();
  btnBloquear: boolean = false;
  dialogConfirmacionClose: boolean = false;
  loadingService = new LoadingService();

  //Axios
  axiosClientes: AxiosVue = new AxiosVue(ServicioProxy.Cliente);

  mounted() {
    this.initialize();
  }

  @Watch('show')
  async onPropertyChanged(value: boolean, oldValue: boolean) {
    this.dialog = value;
    this.bottomNav = '1';
    this.btnText = 'Continuar';

    // permisos
    this.chequearPermisosEditarDetalle();
    this.setBotonNav();

    if (value) {
      this.loadingService.showLoading();
      this.btnBloquear = false;
      this.editedItem = this.cliente;

      this.editedItem.accesoUsuariosTxt == 'No'
        ? (this.editedItem.accesoUsuarios = false)
        : (this.editedItem.accesoUsuarios = true);

      this.editedItem.recepcionActividadesTxt == 'No'
        ? (this.editedItem.recepcionActividades = false)
        : (this.editedItem.recepcionActividades = true);

      this.editedItem.sincronizarCrmTxt == 'No'
        ? (this.editedItem.sincronizarCrm = false)
        : (this.editedItem.sincronizarCrm = true);

      this.initialize();
      this.loadingService.hideLoading();
    }
    const self = this;
  }

  setBotonNav() {
    var accion = 'Editar';
    var evaluado = false;

    if (!this.esEdicion) {
      accion = 'Ver Detalle';
    }
    this.permisosTotales.forEach(obj => {
      if (obj.visible && obj.accion.includes(accion) && !evaluado) {
        this.bottomNav = obj.step;
        evaluado = true;
      }
    });
  }

  async confirmCallback(val: boolean) {
    this.dialogConfirmacion = false;

    if (val) {
      this.btnBloquear = true;
      this.loadingService.showLoading();

      let model = this.editedItem;

      await this.axiosClientes.http
        .put(`Cliente`, model)
        .then(res => {
          this.editedItem.id = res.data.id;

          this.$snotify.success(
            this.$t('mensajes.mensajesExito.editar', {
              entidad: 'El cliente',
              creadoA: 'editado',
            })
          );
          this.closeModal(false);
        })
        .catch(error => {
          //he.showError(error);
          if (error.response !== undefined) {
            if (error.response.status !== 401) {
              this.$snotify.error(
                this.$t('mensajes.mensajesError.editar', {
                  entidad: 'el cliente',
                })
              );
            }
          } else {
            this.$snotify.error(
              this.$t('mensajes.mensajesError.editar', {
                entidad: 'el cliente',
              })
            );
          }
        });
    }
    this.btnBloquear = false;
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }

  //performance
  errorCallback(error: any) {
    this.btnBloquear = false;
    this.loadingService.hideLoading();
    this.handleErrors.showError(error);
  }

  closeModal(val: boolean) {
    this.$validator.reset();
    document.getElementById('cardDivRT').scrollIntoView(true);
    this.btnBloquear = false;
    this.editedItem = {};
    this.$emit('modalAsociacionEmit', false);
    this.dialog = false;
  }

  initialize() {
    this.dictionaryFormErrors = {
      custom: {
        clienteId: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
        },
        nombre: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
        },
        descripcion: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
        },
        cliente: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
  }
}
